import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TruckSize } from '../../../../../../common/constants';
import { ControlProperty } from '../../../../../../common/models';
import { SealPhotosModel } from '../allocation-seal-picture-control';
import { sealPictureControlValidator } from '../allocation-seal-picture-control/allocation-seal-picture-control.validators';
import { AllocationViewSealForm } from '../allocation-security';
import {
  AllocationViewActionRequestSlotModel,
  AllocationViewActionRequestUliModel,
} from '../allocation-view-action-request.model';
import {
  AllocationViewLoanedEquipmentViewForm,
  AllocationViewLoanedEquipmentViewModel,
} from '../allocation-view-loaned-equipment.model';

export class AllocationViewTruckReleaseModel {
  carrierId: string;
  carrierName: string;
  carrierNumber: string;
  freeTextCarrierName: string;
  hubId: number;
  loanedEquipment: AllocationViewLoanedEquipmentViewModel;
  slot: AllocationViewActionRequestSlotModel;
  truckId: number;
  ulis: AllocationViewActionRequestUliModel[];
  firstName: string;
  lastName: string;
  trailerPlateId: string;
  trailerPlateIdCountryOfOrigin: string;
  truckPlateId: string;
  truckPlateIdCountryOfOrigin: string;
  truckSize: TruckSize;
  compartmentNames: string[];
  dangerousGoods: boolean;
  sealCheckData: SealPhotosModel;
  needSealing: boolean;
}

export class AllocationViewTruckReleaseForm {
  constructor(
    model: AllocationViewTruckReleaseModel,
    fb: UntypedFormBuilder,
    dualSealCheckEnabled: boolean,
    public generalInformation: UntypedFormGroup = fb.group(
      new AllocationViewTruckReleaseGeneralInformationForm(model, fb),
    ),
    public sealCheck: UntypedFormGroup = fb.group(new AllocationViewTruckReleaseSealCheckForm(model, fb), {
      validators: dualSealCheckEnabled && model.needSealing ? sealPictureControlValidator : [],
    }),
  ) {}
}

export class AllocationViewTruckReleaseGeneralInformationForm {
  public loanedEquipment: UntypedFormGroup;

  constructor(
    model: AllocationViewTruckReleaseModel,
    fb: UntypedFormBuilder,
    public hubId: ControlProperty<number> = [model.hubId, []],
    public slot: ControlProperty<AllocationViewActionRequestSlotModel> = [model.slot, []],
    public truckId: ControlProperty<number> = [model.truckId, []],
    public ulis: ControlProperty<AllocationViewActionRequestUliModel[]> = [model.ulis, []],
    public carrierId: ControlProperty<string> = [model.carrierId, []],
    public carrierName: ControlProperty<string> = [model.carrierName, []],
    public carrierNumber: ControlProperty<string> = [model.carrierNumber, []],
    public freeTextCarrierName: ControlProperty<string> = [model.freeTextCarrierName, []],
    public firstName: ControlProperty<string> = [model.firstName, []],
    public lastName: ControlProperty<string> = [model.lastName, []],
    public trailerPlateId: ControlProperty<string> = [model.trailerPlateId, []],
    public trailerPlateIdCountryOfOrigin: ControlProperty<string> = [model.trailerPlateIdCountryOfOrigin, []],
    public truckPlateId: ControlProperty<string> = [model.truckPlateId, []],
    public truckPlateIdCountryOfOrigin: ControlProperty<string> = [model.truckPlateIdCountryOfOrigin, []],
    public truckSize: ControlProperty<string> = [model.truckSize, []],
    public compartmentNames: ControlProperty<string[]> = [model.compartmentNames, []],
    public dangerousGoods: ControlProperty<boolean> = model.dangerousGoods,
  ) {
    if (model.loanedEquipment) {
      this.loanedEquipment = fb.group(new AllocationViewLoanedEquipmentViewForm(model.loanedEquipment, fb));
    }
  }
}

export class AllocationViewTruckReleaseSealCheckForm {
  constructor(
    model: AllocationViewTruckReleaseModel,
    fb: UntypedFormBuilder,
    public truckSealData: UntypedFormGroup = fb.group(new AllocationViewSealForm(model.sealCheckData?.truckSealData)),
    public trailerSealData: UntypedFormGroup = fb.group(
      new AllocationViewSealForm(model.sealCheckData?.trailerSealData),
    ),
    public trailerPlate: ControlProperty<string> = model.trailerPlateId,
  ) {}
}
